import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { MaintenanceActions } from "redux/actions/settings/MaintenanceActions";
import { ModalActions } from "redux/actions/ModalActions";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { Maintenance } from "models/Maintenance";
import { TableColumn, Table, TableRow } from "app/components/common/Table";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { Translations } from "models/Translations";
import Translator from "app/components/common/Translator";

interface Props {
    fetchMaintenances: typeof MaintenanceActions.fetchMaintenances;
    addMaintenanceForm: typeof ModalActions.showModal;
    addMaintenance: typeof MaintenanceActions.addMaintenance;
    editMaintenanceForm: typeof ModalActions.showModal;
    editMaintenance: typeof MaintenanceActions.editMaintenance;
    deleteMaintenance: typeof MaintenanceActions.deleteMaintenance
    loginUser: LoginUser;
    maintenances: Maintenance[];
    translations: Translations;
}

class MaintenancesComp extends React.Component<Props> {
    componentDidMount() {
        if (this.loggedIn()) {
            if (!this.props.maintenances)
                this.props.fetchMaintenances(this.props.loginUser.token);
        }
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.maintenances
    }

    setMachineData(): TableRow[] {
        let data: TableRow[] = [];
        {
            this.props.maintenances.forEach(maintenance => {
                data.push({
                    dataObject: {
                        id: maintenance.id,
                        name: maintenance.name,
                        description: maintenance.description,
                        archivedDate: maintenance.archivedDate
                    }
                })
            })
        }
        return data;
    }

    setColumns(): TableColumn[] {
        // TODO maybe dynamic??
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'Maintenance',
                accessor: 'name',
            },
            {
                header: 'Description',
                accessor: 'description',
            }
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Maintenance" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Maintenance" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addMaintenance}
                        addFormAction={this.props.addMaintenanceForm}
                        addFormData={{
                            header: "Add a new Maintenance",
                            formObject: Maintenance.empty(),
                        }}
                        editAction={this.props.editMaintenance}
                        editFormAction={this.props.editMaintenanceForm}
                        editFormData={{
                            header: "Edit Maintenance",
                        }}
                        deleteAction={this.props.deleteMaintenance}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setMachineData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        maintenances: state.maintenances,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchMaintenances: bindActionCreators(MaintenanceActions.fetchMaintenances, dispatch),
        addMaintenance: bindActionCreators(MaintenanceActions.addMaintenance, dispatch),
        addMaintenanceForm: bindActionCreators(ModalActions.showModal, dispatch),
        editMaintenance: bindActionCreators(MaintenanceActions.editMaintenance, dispatch),
        editMaintenanceForm: bindActionCreators(ModalActions.showModal, dispatch),
        deleteMaintenance: bindActionCreators(MaintenanceActions.deleteMaintenance, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MaintenancesComp);